var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12 0c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12zm0 17.5c-7.5 0-7.5 0-7.5-5.5s0-5.5 7.5-5.5 7.5 0 7.5 5.5 0 5.5-7.5 5.5zm-2-2.5 5-3-5-3v6z"}));
}

Youtube.defaultProps = {"width":"26","height":"26","enableBackground":"new 0 0 24 24","version":"1.1","viewBox":"0 0 24 24","xmlSpace":"preserve"};

module.exports = Youtube;

Youtube.default = Youtube;
